<template>
  <div class="navigation">
    <router-link
      v-for="item in navigationItems"
      :key="item.name"
      :to="{ name: item.name }"
      class="navigation-item"
    >
      <component class="icon" :is="`${item.name}-icon`" :fill="calculateFill(item)" />
      <span>{{ item.label }}</span>
    </router-link>
  </div>
</template>

<script>
import IndicatorsIcon from '@/components/icons/IndicatorsIcon.vue';
import ModelsIcon from '@/components/icons/ModelsIcon.vue';
import BannerIcon from '@/components/icons/BannerIcon.vue';

export default {
  name: 'navigation',

  components: {
    IndicatorsIcon,
    ModelsIcon,
    BannerIcon,
  },

  methods: {
    calculateFill(item) {
      return this.$route.path.includes(item.name) ? '#4ba82e' : '#000';
    },
  },

  data() {
    return {
      navigationItems: [
        {
          name: 'indicators',
          label: 'Индикаторы',
        },
        {
          name: 'models',
          label: 'Модели',
        },
        {
          name: 'banner',
          label: 'Баннер',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  padding: 20px 30px;

  .navigation-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0;
    cursor: pointer;
    text-decoration: none;
    color: var(--black-color);

    &.router-link-active {
      color: var(--green-color);
    }

    .icon {
      width: 18px;
      height: 18px;
    }

    span {
      margin-left: 10px;
    }
  }
}
</style>
